import React from 'react'
import { Set } from 'immutable'
import AttributedHtmlText from '#src/components/AttributedHtmlText'
import { PlainInputSelectable, Group } from '#src/components/Path/Selectable'
import { ListPathFlowQuestionProps } from '../'
import styles from './styles.css'

const MultiSelectPillsQuestion: React.SFC<ListPathFlowQuestionProps> = ({
  question,
  onFieldValueChanged,
  onFieldValidityChanged,
  className
}) => {
  const defaultValues = question.listUserInput.value ? Set(question.listUserInput.value) : Set()

  return (
    <div className={styles.grid}>
      <Group
        name={question.internalName}
        onSelect={values => {
          onFieldValueChanged({ value: [...values] })
        }}
        multiple={true}
        defaultValues={defaultValues}
        onValid={() => onFieldValidityChanged(true)}
        onInvalid={() => onFieldValidityChanged(false)}
      >
        {question.choices.map(choice => {
          const headline = choice.text ? <AttributedHtmlText text={choice.text} /> : ''

          return (
            <PlainInputSelectable
              key={choice.value}
              value={choice.value}
              classes={{
                default: styles.pill,
                selected: styles.selected
              }}
              className={className}
            >
              {headline}
            </PlainInputSelectable>
          )
        })}
      </Group>
    </div>
  )
}

export default MultiSelectPillsQuestion
